import { render, staticRenderFns } from "./addnewquotation.vue?vue&type=template&id=1a185ddc"
import script from "./addnewquotation.vue?vue&type=script&lang=js"
export * from "./addnewquotation.vue?vue&type=script&lang=js"
import style0 from "./addnewquotation.vue?vue&type=style&index=0&id=1a185ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports